import React from "react";

// 統一的 SVG 圖標，配色與 Vapor 綠色主題一致
const iconStyle = {
  width: 48,
  height: 48,
};

// 1. 無需手機號碼 - 手機 + 斜線
export const IconNoPhone = () => (
  <svg style={iconStyle} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="14" y="6" width="20" height="36" rx="4" stroke="#00d46a" strokeWidth="2.5" />
    <circle cx="24" cy="36" r="2" fill="#00d46a" />
    <rect x="18" y="12" width="12" height="2" rx="1" fill="#A3FFBE" />
    <line x1="8" y1="40" x2="40" y2="8" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

// 2. 零資料外洩 - 盾牌 + 勾
export const IconShield = () => (
  <svg style={iconStyle} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4L6 12v12c0 11 8 18 18 22 10-4 18-11 18-22V12L24 4z" stroke="#00d46a" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M24 4L6 12v12c0 11 8 18 18 22 10-4 18-11 18-22V12L24 4z" fill="#00d46a" fillOpacity="0.08" />
    <path d="M16 24l6 6 10-12" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// 3. 安全路徑 - 洋蔥路由節點
export const IconOnionRoute = () => (
  <svg style={iconStyle} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="24" r="4" fill="#00d46a" />
    <circle cx="24" cy="10" r="4" fill="#61F78D" />
    <circle cx="24" cy="38" r="4" fill="#61F78D" />
    <circle cx="40" cy="24" r="4" fill="#A3FFBE" />
    <path d="M12 23l8-10M12 25l8 10M28 12l8 9M28 36l8-9" stroke="#00d46a" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="3 3" />
    <circle cx="24" cy="24" r="10" stroke="#00d46a" strokeWidth="1.5" strokeOpacity="0.3" strokeDasharray="4 3" />
  </svg>
);

// 4. 開放原始碼 - 程式碼括號
export const IconOpenSource = () => (
  <svg style={iconStyle} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="8" width="36" height="32" rx="4" stroke="#00d46a" strokeWidth="2.5" />
    <rect x="6" y="8" width="36" height="32" rx="4" fill="#00d46a" fillOpacity="0.06" />
    <path d="M18 20l-5 4 5 4" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M30 20l5 4-5 4" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="26" y1="17" x2="22" y2="31" stroke="#A3FFBE" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// 5. 社群驅動 - 人群網絡
export const IconCommunity = () => (
  <svg style={iconStyle} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="14" r="5" stroke="#00d46a" strokeWidth="2.5" />
    <circle cx="24" cy="14" r="5" fill="#00d46a" fillOpacity="0.1" />
    <path d="M14 38c0-5.5 4.5-10 10-10s10 4.5 10 10" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="10" cy="20" r="3.5" stroke="#61F78D" strokeWidth="2" />
    <path d="M4 34c0-3.3 2.7-6 6-6" stroke="#61F78D" strokeWidth="2" strokeLinecap="round" />
    <circle cx="38" cy="20" r="3.5" stroke="#61F78D" strokeWidth="2" />
    <path d="M44 34c0-3.3-2.7-6-6-6" stroke="#61F78D" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// 6. 無追蹤器 - 眼睛 + 斜線
export const IconNoTracker = () => (
  <svg style={iconStyle} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 24s8-14 20-14 20 14 20 14-8 14-20 14S4 24 4 24z" stroke="#00d46a" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M4 24s8-14 20-14 20 14 20 14-8 14-20 14S4 24 4 24z" fill="#00d46a" fillOpacity="0.06" />
    <circle cx="24" cy="24" r="6" stroke="#00d46a" strokeWidth="2.5" />
    <circle cx="24" cy="24" r="2" fill="#A3FFBE" />
    <line x1="8" y1="40" x2="40" y2="8" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

const PrivacyIcons = [
  IconNoPhone,
  IconShield,
  IconOnionRoute,
  IconOpenSource,
  IconCommunity,
  IconNoTracker,
];

export default PrivacyIcons;
